import React from "react";

const LightGalleryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78">
    <defs>
      <filter id="a" width="78" height="78" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset dy="3" />
        <feGaussianBlur result="blur" stdDeviation="3" />
        <feFlood floodOpacity=".322" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g data-name="gallery icon 60px-light">
      <g filter="url(#a)">
        <circle cx="30" cy="30" r="30" data-name="Ellipse 68" transform="translate(9 6)" fill="#fff" opacity=".8" />
      </g>
      <path
        d="M49.667 45.333v.888A2.666 2.666 0 0147 48.888H25.667A2.666 2.666 0 0123 46.221V32a2.666 2.666 0 012.667-2.667h.889v11.555A4.45 4.45 0 0031 45.333zM55 40.888V26.667A2.666 2.666 0 0052.333 24H31a2.666 2.666 0 00-2.667 2.667v14.221A2.666 2.666 0 0031 43.555h21.333A2.666 2.666 0 0055 40.888zM37.223 29.333a2.667 2.667 0 11-2.667-2.667 2.668 2.668 0 012.667 2.667zm-5.333 8l3.084-3.084a.665.665 0 01.943 0l2.195 2.195 7.529-7.528a.665.665 0 01.943 0l4.861 4.861V40H31.889z"
        data-name="Path 498"
        fill="#121212"
      />
    </g>
  </svg>
);

export default LightGalleryIcon;
